import 'zone.js'
import { bootstrapApplication } from '@angular/platform-browser'
import { provideAnimations } from '@angular/platform-browser/animations'
import { Provider } from '@angular/core'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { AppComponent } from './app/app.component'
import { mockApiInterceptor } from './app/mock-data/mock-api.interceptor'
import { provideAchTransactionDetails } from '../../../projects/ach-transaction-details/src/public-api'
import { environment } from './environments/environment'

const achProviders: Provider[] = environment.useMockData
    ? [provideAchTransactionDetails({ bffBaseUrl: '' })]
    : [provideAchTransactionDetails({ bffBaseUrl: environment.bffBaseUrl })]

const httpProviders = environment.useMockData
    ? [provideHttpClient(withInterceptors([mockApiInterceptor]))]
    : [provideHttpClient()]

bootstrapApplication(AppComponent, {
    providers: [provideAnimations(), ...httpProviders, ...achProviders],
}).catch((err) => console.error(err))
